import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { apiFetch } from "@/api/client";
import { errorMessage } from "@/api/errors";
import { useAuthStore } from "@/stores/auth";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const setSession = useAuthStore((s) => s.setSession);
  const navigate = useNavigate();
  const [sp] = useSearchParams();

  useEffect(() => {
    if (sp.get("expired") === "1") {
      toast.error("登录已过期，请重新登录");
    }
  }, [sp]);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await apiFetch("/auth/login", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      });
      const data = await r.json();
      if (!r.ok) {
        toast.error(errorMessage(data));
        return;
      }
      setSession(data);
      toast.success(`欢迎回来，${data.user.displayName || data.user.email}`);
      const next = sp.get("next") || "/";
      navigate(next, { replace: true });
    } catch (e) {
      toast.error(errorMessage(e, "网络异常"));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted px-4">
      <form
        onSubmit={onSubmit}
        className="bg-background w-full max-w-sm rounded-lg border border-border p-8 shadow-sm space-y-5"
      >
        <div>
          <h1 className="text-xl font-semibold">Meta Ads 管理平台</h1>
          <p className="text-muted-foreground text-sm mt-1">登录到你的账户</p>
        </div>

        <label className="block space-y-1.5">
          <span className="text-sm font-medium">邮箱</span>
          <input
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary/40"
            placeholder="you@company.com"
          />
        </label>

        <label className="block space-y-1.5">
          <span className="text-sm font-medium">密码</span>
          <input
            type="password"
            required
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary/40"
          />
        </label>

        <button
          type="submit"
          disabled={busy}
          className="w-full rounded-md bg-primary text-primary-foreground py-2 text-sm font-medium hover:opacity-90 disabled:opacity-50"
        >
          {busy ? "登录中..." : "登录"}
        </button>
      </form>
    </div>
  );
}
